import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { TablePagination } from "@mui/material";

const Pagination = ({
  disabled,
  hideIfEmpty,
  onChange,
  onPageChange,
  page,
  perPage,
  totalCount,
}) => {
  const rowsPerPageOptions = [25, 50, 100, 200, 400, 800];

  const isValidTotalCount = Number.isInteger(totalCount) && totalCount >= 0;
  const safeTotalCount = isValidTotalCount ? totalCount : 0;

  if (hideIfEmpty && safeTotalCount === 0) {
    return null;
  }

  const isValidPage = Number.isInteger(page) && page >= 0;
  const safePage = isValidPage ? page : 0;

  const isValidPerPage = Number.isInteger(perPage) && perPage > 0;
  const safePerPage = isValidPerPage ? perPage : rowsPerPageOptions[0];

  const lastPage = Math.max(0, Math.ceil(safeTotalCount / safePerPage) - 1);

  const isFirstPage = safePage === 0;
  const isLastPage = safePage === lastPage;

  const isInvalid = !isValidPage || !isValidPerPage || !isValidTotalCount;
  const isDisabled = disabled || isInvalid;

  const isPageNavigationDisabled = isDisabled || typeof onPageChange !== "function";
  const isRowsPerPageDisabled = isDisabled || typeof onChange !== "function";

  return (
    <TablePagination
      component="div"
      count={safeTotalCount}
      labelDisplayedRows={
        ({ from, to, count }) => (
          <FormattedMessage
            id="pagination.displayedItems"
            values={{ from, to, count }}
          />
        )
      }
      labelRowsPerPage={
        <FormattedMessage id="pagination.itemsPerPage" />
      }
      onPageChange={onPageChange}
      onRowsPerPageChange={onChange}
      page={safePage}
      rowsPerPage={safePerPage}
      rowsPerPageOptions={rowsPerPageOptions}
      backIconButtonProps={{ disabled: isPageNavigationDisabled || isFirstPage }}
      nextIconButtonProps={{ disabled: isPageNavigationDisabled || isLastPage }}
      SelectProps={{ disabled: isRowsPerPageDisabled }}
    />
  );
};

Pagination.defaultProps = {
  disabled: false,
  hideIfEmpty: false,
};

Pagination.propTypes = {
  disabled: PropTypes.bool,
  hideIfEmpty: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
};

Pagination.displayName = "Pagination";

export default Pagination;
